export enum MemoTextMarkdownTypeEnum {
    COMPANY_SUMMARY = "company_summary",
}

export enum MemoTextJsonTypeEnum {
    COMPANY_METADATA = "company_metadata",
}

export enum MemoTextCompetitiveAnalysisTypeEnum {
    COMPETITIVE_ANALYSIS = "competitive_analysis",
}

export enum MemoTextBackgroundCheckTypeEnum {
    BACKGROUND_CHECK = "background_check",
}

export interface MemoTextBackgroundCheck {
    type: MemoTextBackgroundCheckTypeEnum;
    modifiedAt: string;
    modifiedBy: string;
    markdown: string;
}

export interface MemoTextCompanySummary {
    type: MemoTextMarkdownTypeEnum;
    modifiedAt: string;
    modifiedBy: string;
    markdown: string;
}

export interface MemoTextCompetitiveAnalysis {
    type: MemoTextCompetitiveAnalysisTypeEnum;
    modifiedAt: string;
    modifiedBy: string;
    markdown: string;
}

export interface MemoTextCompanyMetadataData {
    headcountEstimate: number;
    companyWebsite: string;
    city?: string;
    state?: string;
    countryCode?: string;
    naicsCode: string;
    otherWebsites?: string[];
}

export interface MemoTextCompanyMetadata {
    type: MemoTextJsonTypeEnum;
    modifiedAt: string;
    modifiedBy: string;
    data: MemoTextCompanyMetadataData;
}

export type MemoTextTypeEnum =
    | MemoTextMarkdownTypeEnum
    | MemoTextJsonTypeEnum
    | MemoTextCompetitiveAnalysisTypeEnum
    | MemoTextBackgroundCheckTypeEnum;

export type MemoText =
    | MemoTextCompanySummary
    | MemoTextCompanyMetadata
    | MemoTextCompetitiveAnalysis
    | MemoTextBackgroundCheck;

export type MemoTextObject = {
    [MemoTextMarkdownTypeEnum.COMPANY_SUMMARY]?: MemoTextCompanySummary;
    [MemoTextJsonTypeEnum.COMPANY_METADATA]?: MemoTextCompanyMetadata;
    [MemoTextCompetitiveAnalysisTypeEnum.COMPETITIVE_ANALYSIS]?: MemoTextCompetitiveAnalysis;
    [MemoTextBackgroundCheckTypeEnum.BACKGROUND_CHECK]?: MemoTextBackgroundCheck;
};

export type MemoTextTypeParams = {
    companyId: string;
    type?: MemoTextTypeEnum;
};
